<template>
  <!-- <div class="topBar" v-if="$store.getters['dom/isMobile']">
		<img  class="logo" src="~@/assets/images/logo-mainmenu.svg" alt="NYI logo" />
		<a href="#" class="optInOffer">VIEW OPT IN OFFER</a>
	</div> -->
  <div class="intro" :class="playerActiveClass">
    <div class="video" :scroll="handleScroll">
      <!-- <iframe class="embed-responsive-item" id="ytplayer" type="text/html" width="100%" height="100%" src="https://www.youtube.com/embed/QhzjAS3SPqk?&autoplay=1&loop=1&mute=0&rel=0&showinfo=0&controls=1&color=white&iv_load_policy=3&playlist=QhzjAS3SPqk" frameborder="0" allow="autoplay; fullscreen" ></iframe> -->
      <vueVimeoPlayer
        class="player"
        ref="player"
        :video-url="videoURL"
        :options="options"
      ></vueVimeoPlayer>
      <div class="description">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="195"
          height="24"
          viewBox="0 0 195 24"
          fill="none"
        >
          <path
            d="M188.178 0L181.027 0L187.224 23.3584L194.375 23.3584L188.178 0Z"
            fill="#F16924"
          />
          <path
            d="M177.214 0L170.063 0L176.26 23.3584L183.411 23.3584L177.214 0Z"
            fill="#F16924"
          />
          <path
            d="M166.25 0L159.099 0L165.296 23.3584L172.447 23.3584L166.25 0Z"
            fill="#F16924"
          />
          <path
            d="M154.809 0L147.658 0L153.855 23.3584L161.006 23.3584L154.809 0Z"
            fill="#F16924"
          />
          <path
            d="M136.098 11.9175L-0.000107631 11.9175"
            stroke="url(#paint0_linear_255_572)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_255_572"
              x1="135.75"
              y1="12.1793"
              x2="-4.25012"
              y2="12.1794"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.453125" stop-color="#F16924" />
              <stop offset="1" stop-color="#F16924" stop-opacity="0" />
            </linearGradient>
          </defs>
        </svg>
        <h2>SCROLL TO ENTER</h2>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="195"
          height="24"
          viewBox="0 0 195 24"
          fill="none"
        >
          <path
            d="M6.19712 0L13.3476 0L7.15052 23.3584L0 23.3584L6.19712 0Z"
            fill="#F16924"
          />
          <path
            d="M17.1615 0L24.312 0L18.1149 23.3584L10.9644 23.3584L17.1615 0Z"
            fill="#F16924"
          />
          <path
            d="M28.1253 0L35.2759 0L29.0787 23.3584L21.9282 23.3584L28.1253 0Z"
            fill="#F16924"
          />
          <path
            d="M39.5663 0L46.7168 0L40.5197 23.3584L33.3691 23.3584L39.5663 0Z"
            fill="#F16924"
          />
          <path
            d="M58.2769 11.9175L194.375 11.9175"
            stroke="url(#paint0_linear_255_579)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_255_579"
              x1="58.6251"
              y1="12.1793"
              x2="198.625"
              y2="12.1794"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#F16924" />
              <stop offset="1" stop-color="#F16924" stop-opacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div class="overlay" :class="{ hide: !muted }"></div>
    </div>
    <img class="video-bg" src="~images/intro-video.jpg" />
    <div
      v-if="$store.getters['dom/isMobile']"
      class="play"
      :class="{ hide: !muted }"
      @click="modalOpened = !modalOpened"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="98"
        height="104"
        viewBox="0 0 98 104"
        fill="none"
      >
        <path
          opacity="0.5"
          d="M90.3584 49.1892C90.3584 72.3072 71.7532 91.0106 48.8485 91.0106C25.9438 91.0106 7.33853 72.3072 7.33853 49.1892C7.33853 26.0711 25.9438 7.3677 48.8485 7.3677C71.7532 7.3677 90.3584 26.0711 90.3584 49.1892Z"
          fill="#D9D9D9"
          stroke="#D9D9D9"
          stroke-width="6.30303"
        />
        <path
          opacity="0.8"
          d="M81.6316 49.1893C81.6316 67.4256 66.9513 82.2044 48.848 82.2044C30.7446 82.2044 16.0643 67.4256 16.0643 49.1893C16.0643 30.9531 30.7446 16.1743 48.848 16.1743C66.9513 16.1743 81.6316 30.9531 81.6316 49.1893Z"
          fill="#D9D9D9"
          stroke="#D9D9D9"
          stroke-width="0.787879"
        />
        <path
          d="M43.0586 37.5294L61.254 49.1891L43.0586 60.8488V37.5294Z"
          fill="#F16924"
        />
      </svg>
      <span> Play Video </span>
    </div>
    <div v-else class="play" :class="{ hide: !muted }" @click="toggleMute()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="98"
        height="104"
        viewBox="0 0 98 104"
        fill="none"
      >
        <path
          opacity="0.5"
          d="M90.3584 49.1892C90.3584 72.3072 71.7532 91.0106 48.8485 91.0106C25.9438 91.0106 7.33853 72.3072 7.33853 49.1892C7.33853 26.0711 25.9438 7.3677 48.8485 7.3677C71.7532 7.3677 90.3584 26.0711 90.3584 49.1892Z"
          fill="#D9D9D9"
          stroke="#D9D9D9"
          stroke-width="6.30303"
        />
        <path
          opacity="0.8"
          d="M81.6316 49.1893C81.6316 67.4256 66.9513 82.2044 48.848 82.2044C30.7446 82.2044 16.0643 67.4256 16.0643 49.1893C16.0643 30.9531 30.7446 16.1743 48.848 16.1743C66.9513 16.1743 81.6316 30.9531 81.6316 49.1893Z"
          fill="#D9D9D9"
          stroke="#D9D9D9"
          stroke-width="0.787879"
        />
        <path
          d="M43.0586 37.5294L61.254 49.1891L43.0586 60.8488V37.5294Z"
          fill="#F16924"
        />
      </svg>
      <span> Play with sound </span>
    </div>
    <div class="mute-btn" :class="{ hide: muted }" @click="stopVideo()">
      STOP VIDEO
    </div>
    <ModalVideo
      v-if="modalOpened"
      :modalOpened="modalOpened"
      @close-modal="closeModal"
    />
  </div>
</template>

<script>
import { vueVimeoPlayer } from "vue-vimeo-player";
import ModalVideo from "@/components/ModalVideo.vue";

export default {
  name: "LandingVideo",
  components: {
    vueVimeoPlayer,
    ModalVideo,
  },
  data() {
    return {
      videoID: "5e7d7ba74a",
      videoURL: "https://player.vimeo.com/video/1058319738?h=5e7d7ba74a",
      //height: 100,
      autoPause: false,
      options: {
        responsive: true,
        background: false,
        controls: false,
        autopause: false,
        autoplay: true,
        muted: true,
      },

      playerReady: false,
      playerActiveClass: "active",
      muted: true,
      modalOpened: false,
      // muteVisible: true,
    };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    togglePlay() {
      if (this.playerActiveClass == "active") {
        this.$refs.player.mute();
        this.$refs.player.pause();
        this.playerActiveClass = "";
      } else {
        this.$refs.player.unmute();
        this.$refs.player.play();
        this.playerActiveClass = "active";
      }
    },
    closeModal() {
      this.modalOpened = false;
    },
    toggleMute() {
      if (this.muted) {
        this.$refs.player.play();
        this.$refs.player.unmute();
        this.muted = false;
      } else {
        this.$refs.player.mute();
        this.muted = true;
      }
    },
    stopVideo() {
      this.muted = true;
      this.$refs.player.mute();
      this.$refs.player.pause();
    },
    handleScroll: function (evt, el) {
      if (window.scrollY > 500) {
        if (this.playerActiveClass == "active") {
          this.$refs.player.pause();
          this.playerActiveClass = "";
        }
      }

      return window.scrollY > 100;
    },
  },
};
</script>

<style lang="scss" scoped>
// sub{
// 	bottom: 0.7em ;
// 	font-size: 0.5em ;
// }
.topBar {
  display: flex;
  position: fixed;
  z-index: 12;
  justify-content: space-between;
  align-items: center;
  background-color: theme-var($--ch-theme-primary);
  width: 100%;
  padding: 20px;
  .logo {
    height: 50px;
    width: 50px;
  }
  .optInOffer {
    font-family: "Prompt";
    font-size: 15px;
    color: #ffffff;
    text-align: center;
    font-weight: 700;
    text-transform: uppercase;
    background: #f16924;
    text-decoration: none;
    padding: 8px 20px;
  }
}
.intro {
  height: 100vh;
  width: 100%;
  position: relative;
  overflow: hidden;
  z-index: 12;
  // @include media-breakpoint-down(sm) {
  //   background-color: theme-var($--ch-theme-primary);
  //   height: 100%;
  // }
  // @media only screen and (min-width: 578px) and (max-width: 900px) {
  //   height: 100%;
  //   width: 100%;
  // }
  // @media only screen and (min-width: 900px) and (max-width: 1200px) {
  //   height: 100%;
  //   width: 100%;
  // }

  // &.active {
  //   .play {
  //     opacity: 0;
  //   }
  // }

  @media screen and (max-width: 768px) {
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba($color: #000000, $alpha: 0.3);
    }
  }

  &.deactive {
    opacity: 0;
  }
  .video {
    width: 100%;
    height: 100%;
    position: relative;

    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%);
    // //z-index: 0;
    // display: flex;
    // flex-direction: column;
    // flex-wrap: nowrap;
    // justify-content: center;
    @media only screen and (min-width: 578px) and (max-width: 900px) {
      height: 100%;
    }

    .player {
      :deep(iframe) {
        min-height: 100vh !important;
        background-color: black;
        height: 100vh !important;

        // @media screen and (max-width: 1200px) {
        //   background-color: transparent;
        //   min-height: auto !important;
        //   height: 100% !important;
        // }
      }
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      opacity: 0.6;
      background: #042042;
      mix-blend-mode: multiply;

      &.hide {
        opacity: 0;
      }
    }
  }
  .description {
    position: absolute;
    bottom: 5%;
    left: 50%;
    transform: translate(-50%, -3%);
    z-index: 10;
    width: max-content;
    display: flex;
    gap: 20px;
    align-items: center;

    h2 {
      font-family: "Prompt";
      font-size: 24px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      font-weight: 900;
      margin-bottom: 0;
      @include media-breakpoint-down(sm) {
        font-size: 16px;
      }
    }

    svg {
      @include media-breakpoint-down(sm) {
        width: 125px;
      }
    }
  }
  // .vp-controls {
  //   .play {
  //     display: none;
  //   }
  // }
  .play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(1);
    height: 121px;
    width: auto;
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    transition: all 0.5s ease-in-out;

    @media screen and (max-width: 768px) {
      z-index: 1;
    }

    &.hide {
      opacity: 0;
      pointer-events: none;
    }

    &:hover {
      transform: translate(-50%, -50%) scale(1.1);
    }

    svg {
      width: 90px;
      height: 90px;
    }

    span {
      color: #fff;
      text-transform: uppercase;
      text-align: center;
      font-family: Prompt;
      font-size: 14px;
      font-style: normal;
      font-weight: 900;
      line-height: 24px; /* 150% */
    }
    // border-radius: 50%;
    // background: rgba(162, 138, 100, 0.25);
    transition: all 0.5s ease-in-out;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
    // @media (min-width: $lg) {
    //   display: none;
    // }
  }

  .mute-btn {
    position: absolute;
    top: 30px;
    right: 30px;
    cursor: pointer;
    z-index: 1;
    font-size: 10px;
    font-weight: 900;
    padding: 10px 16px 8px;
    border: 2px solid white;
    background-color: transparent;
    transition: all 0.3s ease-in-out;
    opacity: 1;

    &.hide {
      opacity: 0;
    }

    &:hover {
      background-color: #f16924;
    }
  }

  .video-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: none;

    @media screen and (max-width: 768px) {
      display: block;
    }
  }
}
</style>
